import { INFO } from '../data/general-info';

export const mailSender = {
  url: 'https://api.smtp2go.com/v3/email/send',
  sender: 'admin@fanqueiro2024.pt',
  to: [INFO.organizationEmail],
  bcc: [INFO.personalEmail],
  apiKey: 'api-446E1588427811E9A6BEF23C91BBF4A0',
  subjectBooking: 'Condomínio Fanqueiro 20.24 - Marcação ',
  subjectContact: 'Condomínio Fanqueiro 20.24 - Informações ',
  bookKey: 'book',
  infoKey: 'info',
};
